export default {
  enderecoPrincipal: state => state.enderecoPrincipal
}